import React, { useMemo } from 'react';
import { useLocalesQuery } from '../../../gql/hooks/queries/useLocalesQuery';
import SelectOrTransfer from '../../selectOrTransfer/SelectOrTransfer';

const LanguageSelector = ( { value, onChange, mode = 'select', showSearch = true, searchPlaceholder = 'Search...', ...otherProps } ) => {

    const { data, loading, error } = useLocalesQuery();

    const languageOptions = useMemo( () => {

        if ( loading === true || error || data === undefined ) {
            return [];
        }
        const mappedData = data.locales.edges.map(  ( { node: { code, labelEnUs } } ) => {
            return {
                key: code,
                label: labelEnUs,
            };
        } );

        const sortedData = mappedData.sort( ( optionA, optionB ) => {
            const labelOptionA = ( optionA?.label?.toLowerCase() || '' );
            const labelOptionB = ( optionB?.label?.toLowerCase() || '' );
            return labelOptionA.localeCompare( labelOptionB );
        } );

        return sortedData;
    }, [ data, loading, error ] );

    return (
        <SelectOrTransfer
            mode={ mode }
            dataSource={ languageOptions  }
            value={ value }
            onChange={ onChange }
            showSearch={ showSearch }
            searchPlaceholder={ searchPlaceholder }
            { ...otherProps }
        />
    );
};

export default LanguageSelector;
